export const en = {
  rte: {
    badURL: 'The URL entered is incorrect.',
    maxSizeLimitReachedTooltip:
      'The text is too long for us to safely handle. We are working on solving the issue and are sorry for the inconvenience.',
    readOnlyNoInput: 'None'
  }
};
